export default {
  profileLoadingState: null,
  profileUpdateLoadingState: null,
  profileErrorState: null,
  profileDetailsState: {},
  referralCreationReferredJob: {},
  showRecommendedJobsNotFound: false
};
